import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const NUMBER_OF_PRODUCTS_LABEL = (
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize({
    defaultMessage: "How many wholesale products do you sell?",
    description: {
      text: "Number of wholesale products a prospective brand sells",
    },
  });

export const HEAR_ABOUT_US_LABEL = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "How did you hear about us? (Optional)",
    description: { text: "How a prospective brand heard about Faire" },
  });

export const getLabels = (strictLocalize: StrictLocalizeFunction) => ({
  brand_name: strictLocalize({
    defaultMessage: "Brand Name",
    description: {
      text: "The name of the brand applying to sell on Faire",
    },
  }),
  email_address: strictLocalize({
    defaultMessage: "Email Address",
    description: {
      text: "The email address of the brand applying to sell on Faire",
    },
  }),
  website_url: strictLocalize({
    defaultMessage: "Website URL",
    description: {
      text: "The website url of the brand applying to sell on Faire",
    },
  }),
  primary_category: strictLocalize({
    defaultMessage: "Primary Category",
    description: {
      text: "The primary category of products that a prospective brand sells",
    },
  }),
  secondary_category: strictLocalize({
    defaultMessage: "Secondary Category",
    description: {
      text: "The secondary category of products within the primary category.",
    },
  }),
  country: strictLocalize({
    defaultMessage: "Country of Tax Residence",
    description: {
      text: "The country where a prospective brand is based in, for tax purposes.",
      img: "https://cdn.faire.com/fastly/be20448c7dc9e0af173b426caf4a3637fb92841651693897e2714848b124b2fa.png",
    },
  }),
  number_of_stores: strictLocalize({
    defaultMessage: "How many independent stores do you work with?",
    description: {
      text: "Number of independent stores a prospective brand works with",
    },
  }),
  phone_number: strictLocalize({
    defaultMessage: "What's your phone number?",
    description: { text: "Asking for user's phone number." },
  }),
});
